import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { useCheckout } from '@/b2c/checkout/useCheckout';
import { provideStepReset } from '@/b2c/checkout/useStepReset';
import {
    CheckOutDeliverable,
    CheckoutDeliverableType,
    CheckOutDeliverableWithAddress,
    ClickAndCollectCheckOutDeliverable,
    CustomerDeliveryCheckOutDeliverable,
    PickUpCheckOutDeliverable,
} from '@/b2c/shared/api/server-apis';
import { computed } from 'vue';
import type { Component } from 'vue';
import useScrollToElement from '@/shared/navigation/useScrollToElement';
import CheckoutClickAndCollectDeliverable
    from '@/b2c/checkout/ui/deliverables/CheckoutClickAndCollectDeliverable.vue';
import CheckoutPickAndPackDeliverable from '@/b2c/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackDeliverable.vue';
import CheckoutPickUpDeliverable from '@/b2c/checkout/ui/deliverables/CheckoutPickUpDeliverable.vue';
import CheckoutCustomerDeliverable from '@/b2c/checkout/ui/deliverables/CheckoutCustomerDeliverable.vue';
import CheckoutGiftCardDeliverable from '@/b2c/checkout/ui/deliverables/CheckoutGiftCardDeliverable.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutDeliverable',
  props: {
    deliverable: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: CheckOutDeliverable | CheckOutDeliverableWithAddress | CustomerDeliveryCheckOutDeliverable | PickUpCheckOutDeliverable | ClickAndCollectCheckOutDeliverable;
    index: number;
}



const labels = useBlockLabels();
const { step, updateStep, basket, isDeliverableStep } = useCheckout();
const isActiveDeliverable = computed(() => step.value === props.index + 1);
const scrollOffsetForFirstStep = computed(() => step.value === 1 ? -135 : -45);
const deliverableToScrollToWhenActive = useScrollToElement(isActiveDeliverable, scrollOffsetForFirstStep);

const resetToChangedStep = () => {
    updateStep(props.index + 1);
};

provideStepReset(resetToChangedStep);

const shouldShowDeliverable = computed(() => {
    return step.value > props.index;
});

const getCheckoutDeliverableComponent = computed<Component>(() => {
    switch (props.deliverable.type) {
    case CheckoutDeliverableType.ClickAndCollect:
        return CheckoutClickAndCollectDeliverable;
    case CheckoutDeliverableType.PickAndPack:
        return CheckoutPickAndPackDeliverable;
    case CheckoutDeliverableType.PickUp:
        return CheckoutPickUpDeliverable;
    case CheckoutDeliverableType.GiftCard:
        return CheckoutGiftCardDeliverable;
    default:
        return CheckoutCustomerDeliverable;
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: _unref(deliverableToScrollToWhenActive),
    class: "mt-x6"
  }, [
    _withDirectives(_createElementVNode("h2", {
      class: _normalizeClass(["o-text-h3 mb-x4 text-center", {'text-silver': !_unref(shouldShowDeliverable)}])
    }, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).deliverableHeader, { step: props.index + 1, steps: _unref(basket)?.deliverables.length })), 3), [
      [_vShow, _unref(isDeliverableStep)]
    ]),
    _createVNode(_Transition, { name: "o-anim-fade-300" }, {
      default: _withCtx(() => [
        (_unref(shouldShowDeliverable))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getCheckoutDeliverableComponent)), {
                key: __props.deliverable.id,
                index: __props.index,
                deliverable: __props.deliverable,
                onInput: resetToChangedStep
              }, null, 40, ["index", "deliverable"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})